import { ReactNode } from 'react';
import { StyledTheme } from './StyledTheme';

export const AppTheme = ({ children }: { children: ReactNode }) => {
  return <StyledTheme>{children}</StyledTheme>;
};

export default AppTheme;
